export const store = {
  debug: false,

  state: {
    searchQuery: ''
  },

  setMessageAction (newValue) {
    if (this.debug) console.log('setMessageAction triggered with', newValue)
    this.state.searchQuery = newValue
  },

  clearMessageAction () {
    if (this.debug) console.log('clearMessageAction triggered')
    this.state.searchQuery = ''
  }
}



// WEBPACK FOOTER //
// ./src/base/Store.js